export default {
    "语言": 1,
    "你好": 2,
    "立即创建": 3,
    "取消": 4
}